import apiClient from './AuthService';

const API_PREFIX = '/admin/architects';

export interface Architect {
    userId: string;
    firstName: string;
    lastName: string;
    username: string;
    role: string;
    hasPendingInvitation: boolean;
}

export const getAllArchitects = async (): Promise<Architect[]> => {
    const response = await apiClient.get<{ data: Architect[] }>(API_PREFIX);
    return response.data.data;
};

export const createArchitect = async (firstName: string, email: string): Promise<any> => {
    const response = await apiClient.post(API_PREFIX, {
        first_name: firstName,
        username: email,
    });
    return response.data;
};

export const updateArchitect = async (id: string, firstName: string, email: string): Promise<any> => {
    const response = await apiClient.put(`${API_PREFIX}/${id}`, {
        first_name: firstName,
        username: email,
    });
    return response.data;
};

export const deleteArchitect = async (id: string): Promise<any> => {
    const response = await apiClient.delete(`${API_PREFIX}/${id}`);
    return response.data;
};

export const resendInvitation = async (id: string): Promise<any> => {
    const response = await apiClient.post(`${API_PREFIX}/${id}/resend-invitation`);
    return response.data;
};
